// Capacitor import removed - always use absolute URL

const BASE_URL = 'https://scores.aprmode.com';

export async function authFetch(path, token) {
  const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
  const res = await fetch(BASE_URL + path, { headers });
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}
export async function authPost(path, body, token) {
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  const res = await fetch(BASE_URL + path, { method: 'POST', headers, body: JSON.stringify(body) });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || 'Request failed');
  return data;
}
export async function authDelete(path, token) {
  const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
  const res = await fetch(BASE_URL + path, { method: 'DELETE', headers });
  return res.json();
}
export async function apiFetch(path) {
  const res = await fetch(BASE_URL + path);
  if (!res.ok) throw new Error(`API error ${res.status}`);
  return res.json();
}
